/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { borderRadius } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const ShortcutGroup = styled.div({
  marginBottom: token('space.200'),
});

export const GroupTitle = styled.h5({
  borderBottom: `2px solid ${token('color.border')}`,
  paddingBottom: token('space.050'),
});

export const Shortcuts = styled.dl({
  paddingLeft: 0,
});

export const Shortcut = styled.div({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: token('space.050'),
});

export const ShortcutKey = styled.kbd({
  alignItems: 'center',
  backgroundClip: 'padding-box',
  border: `1px solid ${token('color.border')}`,
  borderRadius: `${borderRadius()}px`,
  boxSizing: 'border-box',
  display: 'flex',
  backgroundColor: token('color.background.input.hovered'),
  backgroundImage: `linear-gradient( to bottom, ${token(
    'color.background.input.pressed'
  )}, ${token('color.background.input.hovered')} )`,
  backgroundRepeat: 'repeat-x',
  font: token('font.code'),
  justifyContent: 'center',
  margin: '0 2px',
  minHeight: '20px',
  minWidth: '20px',
  padding: '0 5px',
  whiteSpace: 'nowrap',
});
